export default "__VITE_ASSET__BhfZSKht__"